import { jsx as _jsx } from "react/jsx-runtime";
import { FaireProtectionTooltip } from "@faire/retailer-visitor-shared/components/BrandCartCard/components/FaireProtectionTooltip";
import { canAddToCart } from "@faire/retailer-visitor-shared/lib/canAddToCart";
import { isDiscontinued as isProductOptionDiscontinued, isProductOptionInStock } from "@faire/retailer-visitor-shared/lib/productOptions";
import { areRequiredProductCustomizationsApplied, areAppliedProductCustomizationsValid } from "@faire/retailer-visitor-shared/services/ProductCustomization";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var AddToCartButtonBase = function(param) {
    var brandToken = param.brandToken, isInvoice = param.isInvoice, isBrandActive = param.isBrandActive, addToCartNotificationInProgress = param.addToCartNotificationInProgress, isCartInfoLoading = param.isCartInfoLoading, isFaireProtectionLoading = param.isFaireProtectionLoading, productAddToCartState = param.productAddToCartState, product = param.product, productAddCTAOverride = param.productAddCTAOverride, updateCart = param.updateCart, isBrandTokenForbidden = param.isBrandTokenForbidden;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var addToBagText = getAddToBagText(addToCartNotificationInProgress, product, isBrandActive, productAddToCartState, strictLocalize, productAddCTAOverride);
    if (!addToBagText) {
        return null;
    }
    var brandTokenForbidden = isBrandTokenForbidden(brandToken !== null && brandToken !== void 0 ? brandToken : "");
    var disableButton = addToCartDisabled(product, productAddToCartState, isBrandActive, isInvoice);
    if (brandTokenForbidden && !isCartInfoLoading) {
        return /*#__PURE__*/ _jsx(CtaContainer, {
            children: /*#__PURE__*/ _jsx(FaireProtectionTooltip, {
                hidden: false,
                targetNode: /*#__PURE__*/ _jsx(AddToCart, {
                    disabled: true,
                    onClick: updateCart,
                    "data-test-id": "addToCartButton",
                    children: addToBagText
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(AddToCart, {
        disabled: disableButton,
        loading: isCartInfoLoading || isFaireProtectionLoading,
        onClick: updateCart,
        "data-test-id": "addToCartButton",
        children: addToBagText
    });
};
export var AddToCartButton = observer(AddToCartButtonBase);
var isSelectedProductDifferentThanCart = function(productAddToCartState) {
    var selectedQuantity = productAddToCartState.selectedQuantity, productOptionInCart = productAddToCartState.productOptionInCart, includesTesters = productAddToCartState.includesTesters, isSelectedOpenSizingQtyModified = productAddToCartState.isSelectedOpenSizingQtyModified, isOpenSizingVariant = productAddToCartState.isOpenSizingVariant;
    var isProductOptionModified = isOpenSizingVariant ? isSelectedOpenSizingQtyModified : selectedQuantity !== (productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.quantity) || includesTesters !== !!(productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.includes_tester);
    return !productOptionInCart || isProductOptionModified;
};
var addToCartDisabled = function(product, productAddToCartState, isBrandActive, isInvoice) {
    var _product_purchase_information;
    var selectedOption = productAddToCartState.selectedOption, selectedQuantity = productAddToCartState.selectedQuantity, customizations = productAddToCartState.customizations, updateQuantityOnChange = productAddToCartState.updateQuantityOnChange, perStyleOptionVariations = productAddToCartState.perStyleOptionVariations, exceedMaxAvailableUnits = productAddToCartState.exceedMaxAvailableUnits;
    var canAdd = isInvoice || canAddToCart();
    var enableEditProductQuantity = updateQuantityOnChange ? isSelectedProductDifferentThanCart(productAddToCartState) : selectedQuantity !== 0 && !exceedMaxAvailableUnits;
    if (selectedOption === undefined) {
        return true;
    }
    return(// Don't include brand since we handle online ony restricted elsewhere
    !canAdd || !isBrandActive || isProductOptionDiscontinued(product, selectedOption) || !enableEditProductQuantity || !isProductOptionInStock(selectedOption, perStyleOptionVariations) || !areRequiredProductCustomizationsApplied(((_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.customizations) || [], customizations) || !areAppliedProductCustomizationsValid(productAddToCartState.customizationsInMoqCalculation, customizations));
};
var getAddToBagText = function(addToCartNotificationInProgress, product, isBrandActive, productAddToCartState, strictLocalize, productAddCTAOverride) {
    var selectedOption = productAddToCartState.selectedOption, updateQuantityOnChange = productAddToCartState.updateQuantityOnChange, productOptionInCart = productAddToCartState.productOptionInCart, perStyleOptionVariations = productAddToCartState.perStyleOptionVariations, isPreorderableSelected = productAddToCartState.isPreorderableSelected;
    if (selectedOption === undefined || !isBrandActive || isProductOptionDiscontinued(product, selectedOption)) {
        return strictLocalize({
            id: "m50lDw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Unavailable"
                }
            ]
        });
    }
    if (!isProductOptionInStock(selectedOption, perStyleOptionVariations)) {
        return null;
    }
    if (productAddCTAOverride) {
        var isUpdating = !!(updateQuantityOnChange && productOptionInCart);
        return productAddCTAOverride(isUpdating, strictLocalize);
    }
    var isRemovedFromCart = updateQuantityOnChange && !productOptionInCart && addToCartNotificationInProgress;
    return getAddToCartText(updateQuantityOnChange && !!productOptionInCart, isSelectedProductDifferentThanCart(productAddToCartState), isPreorderableSelected, addToCartNotificationInProgress, isRemovedFromCart, strictLocalize);
};
var getAddToCartText = function(updateProductInCart, isSelectedProductDifferentThanCart, isPreorderableSelected, addToCartNotificationInProgress, isRemovedFromCart, strictLocalize) {
    if (updateProductInCart) {
        return isSelectedProductDifferentThanCart ? strictLocalize({
            id: "qet8kL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Update cart"
                }
            ]
        }) : strictLocalize({
            id: "oMMkhN",
            defaultMessage: [
                {
                    type: 0,
                    value: "In cart"
                }
            ]
        });
    }
    if (isPreorderableSelected) {
        return addToCartNotificationInProgress ? strictLocalize({
            id: "ewyuFN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Added to cart"
                }
            ]
        }) : strictLocalize({
            id: "9flwjg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Preorder"
                }
            ]
        });
    }
    return isRemovedFromCart || !addToCartNotificationInProgress ? strictLocalize({
        id: "uAZvca",
        defaultMessage: [
            {
                type: 0,
                value: "Add to cart"
            }
        ]
    }) : strictLocalize({
        id: "Vj/6BU",
        defaultMessage: [
            {
                type: 0,
                value: "Added to cart!"
            }
        ]
    });
};
var CtaContainer = styled(Column).withConfig({
    componentId: "sc-7a2535bd-0"
})([
    "width:100%;"
]);
var AddToCart = styled(Button).withConfig({
    componentId: "sc-7a2535bd-1"
})([
    "width:100%;"
]);
